<template>
	<div
		id="home"
		v-bind:class="{
			classPopup: showPopup,
		}"
	>
		<div name="fade">
			<div class="bg-primary" v-if="!showUpdatePopUp">
				<div class="update-phone py-3">
					<div class="ico pr-3">
						<img src="../assets/img/alert.svg" alt="" width="30" />
					</div>
					<div class="cnt">
						<p class="font-semibold">Please Verify your phone number</p>
						<p>
							Verification always helps you have access to your account. We will
							send a code to <br /><span> {{ telePhone }} </span>.Text fees may
							apply.
						</p>
						<p>
							<a href="/#/updatephone" class="btn btn-outline-light cp">
								Update Phone
							</a>
							<a
								href="javascript:"
								class="btn btn-outline-light ml-2 cp"
								@click="hideUpdatephone"
							>
								Not Now
							</a>
						</p>
					</div>
				</div>
			</div>
		</div>
		<HomeHeader1 title="homeheader" :api-options="this.headerCarouselId" />
		<categoryFav
			title="My List"
			key="mylist"
			api-options="mylist"
			v-if="showfav"
		/>

		<div v-for="(category, index) in homeItems" :key="index">
			<Category
				v-if="
					category.type == 'Playlist' &&
						category.name != 'home_banner_2' &&
						category.name != 'Trending'
				"
				:title="category.name"
				:api-options="category.id"
			/>
			<div v-if="category.type == 'ResumeList' && showResume">
				<ResumeCarousel :title="category.name" api-options="category.id" />
			</div>

			<div  v-if="showSpotLightBanner(category)">
				<HomeHeader2 :title="category.name" :api-options="category.id" />
			</div>
			<div v-if="category.type == 'Playlist' && category.name == 'Trending'">
				<CategoryTrending :title="category.name" :api-options="category.id" />
			</div>
		</div>
	</div>
</template>
<script>
import Header from "@/components/Header.vue";
import Category from "@/components/Category.vue";
import categoryFav from "@/components/categoryFav.vue";
// import Carousel from '@/components/Carousel.vue'
import HomeHeader from "@/components/HomeHeader.vue";
import HomeHeader1 from "@/components/HomeHeader1.vue";
import HomeHeader2 from "@/components/HomeHeader2.vue";
import HeaderHome from "@/components/HeaderHome.vue";
import CategoryTrending from "@/components/categoryTrending.vue";
import ResumeCarousel from "../components/ResumeCarousel.vue";

export default {
	name: "home",
	components: {
		Header,
		Category,
		HomeHeader1,
		HomeHeader2,
		HeaderHome,
		categoryFav,
		CategoryTrending,
		ResumeCarousel,
	},
	mounted() {
		window.scroll(0, 0);
		 HelpCrunch('showChatWidget');
	},
	data() {
		return {
			items: [],
			showUpdatePopUp: true,
			nocontent: false,
			homeCategory: [],
			headerCarouselId: null,
			regularCarouselId: null,
			newReleaseId: null,
			newReleaseTitle: "",
			showResumeCarousel: null,
			mobileVerified: null,
			telePhone: " Your Registered Mobile Number",
			homeItems: [],
			continueWatching: {},
			accountData: null
		};
	},
	methods: {
		hideUpdatephone() {
			this.showUpdatePopUp = true;
		},
		showSpotLightBanner(category){
			if(category.metaData && category.metaData.lenght>0 && category.metaData.spotlight && category.metaData.spotlight=='true'){
			 return true;	
			}
			return false;
		},
		getText(val) {
			return this.$store.getters.getGlobalConfigs[val];
		},
		checkSpecialPlan() {
			if (this.$store.state.user.userInfo.subscriptions.length > 0 && this.$store.state.user.userInfo.subscriptions[0].package_id == this.getText('restriction_package')) {
				setTimeout(() => {
					this.$store.commit("showSpecialPopUp", true);
				}, 10)
			}
		}
		
	},
	computed: {
		showfav() {
			if (this.$store.state.user.mylist.length > 0) {
				return true;
			} else {
				return false;
			}
		},
		showResume() {
			if (
				this.$store.state.user.resumelist.length > 0 &&
				this.showResumeCarousel == "TRUE"
			) {
				return true;
			} else {
				return false;
			}
		},
		showPopup() {
			return this.$store.state.showPopup;
		},
		
	},
	created() {
		this.$store.commit("showPopup", false);
		this.showResumeCarousel = this.$store.state.globalconfigs.resume_option;
		this.homeCategory = JSON.parse(
			this.$store.state.globalconfigs.home_category
		);
		this.headerCarouselId = this.$store.state.globalconfigs.header_carousel_id;
		this.regularCarouselId = this.$store.state.globalconfigs.regular_carousel_id;
		this.$store.commit("showdefaultnav", false);
		this.$store.commit("showdefaultFooter", true);
		this.$store.commit("setLoader", true);
		if (this.$store.state.user.logedin == false) {
			this.$store.commit("setLoader", false);
			this.$store.commit("logoutUser");
			this.$router.push("/login");
			return false;
		}
		this.continueWatching.type = "ResumeList";
		this.continueWatching.name = "Continue Watching";
		this.continueWatching.id = "mylist";
		this.$store
			.dispatch("getCatalougeById", this.regularCarouselId)
			.then((res) => {
				this.homeItems = res._embedded.items;
				this.homeItems.splice(1, 0, this.continueWatching);
				this.$store.commit("setLoader", false);
				if (this.$store.state.user.userInfo.profile.telephone == "") {
					this.showUpdatePopUp = false;
				}
			})
			.catch((err) => {
				//this.nocontent = true
				this.$store.commit("setLoader", false);
			});
		this.$store.dispatch("account").then((res) => {
			if (res) {
				this.accountData = res.response;
				this.checkSpecialPlan();
				this.mobileVerified = res.response.profile.mobileVerified;
				if (this.mobileVerified == false) {
					this.showUpdatePopUp = false;
				} else {
					this.showUpdatePopUp = true;
				}
				if (res.response.profile.telephone == "") {
					this.showUpdatePopUp = false;
					this.telePhone = " Your Registered Mobile Number";
				} else {
					this.telephone = res.response.profile.telephone;
				}
			}
		});
		// setTimeout(function(){ self.showUpdatePopUp = false; }, 9000);
	},
	mounted() {
		this.checkSpecialPlan()
	}
};
</script>

<style scoped>
a,
button {
	cursor: pointer;
}
.home-card {
	padding-top: 70px;
	position: relative;
	margin: 0 auto;
	max-width: 80%;
	width: 80%;
}
.no-content {
	text-align: center;
	padding: 50px;
	color: #fff;
}

.owl-nav .disabled {
	display: none;
}

.cp {
	cursor: pointer !important;
}

.classPopup {
	position: fixed;
}
</style>
